<template>
    <div class="c-algolia-search__wrapper c-site-search">
        <site-search-filter></site-search-filter>
        <site-search-results></site-search-results>
    </div>
</template>

<script>
import SiteSearchFilter from "./SiteSearchFilter.vue";
import SiteSearchResults from "./SiteSearchResults.vue";

export default {
    components: {
        SiteSearchResults,
        SiteSearchFilter,
    },
    mounted() {},
    computed: {},
    methods: {},
};
</script>
<style lang="scss"></style>
